import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { func } from 'prop-types';

const styles = {
  icon: {
    color: 'highContrast'
  }
};

function Download({ onDownload }) {
  return <UX2.Element.Icon onClick={ onDownload } icon='download' size='large' style={ styles.icon } />;
}

Download.propTypes = {
  onDownload: func
};

export default Download;
